/**
 * @file industry.js
 * @desc 登陆平台信息
 * @author baibangyi
 */
'use strict';

export default {
    namespaced: true,
    state: {
        ind: {
            /* eslint-disable*/
            law: {
                logo: 'https://lvlin-fe-saas.cdn.bcebos.com/assets/fxb-lawyer-icon.png',
                miniLogo: 'https://lvlin-fe-saas.cdn.bcebos.com/assets/logo-white.png',
                name: '法行宝',
                bg: 'https://lvlin-fe-saas.cdn.bcebos.com/assets/unlogin-bg.png',
                solgan: '',
                bgcolor: '#f9fafd',
                height: '100vh',
                product: 'lvlin'
            }
            /* eslint-enable */

        }
    },
    mutations: {
    },
    actions: {
    }
};
